__turbopack_context__.v({
  "list": "iKdjkG_list",
});
